import { defineComponent as _defineComponent } from 'vue'
import { XCircleIcon } from "@heroicons/vue/solid";

interface Meta {
    valid: boolean;
    touched: boolean;
}

interface Props {
    label?: string;
    name: string;
    errorMessage: string;
    meta: Meta;
    required?: boolean;
    labelPosition?: "top" | "left";
}


export default /*#__PURE__*/_defineComponent({
  __name: '_base',
  props: {
    label: { type: String, required: false, default: "" },
    name: { type: String, required: true },
    errorMessage: { type: String, required: true, default: "" },
    meta: { type: Object, required: true },
    required: { type: Boolean, required: false, default: false },
    labelPosition: { type: String, required: false, default: "top" }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const __returned__ = { props, get XCircleIcon() { return XCircleIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})